function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Side-Bar",
  transform: "translate(-448.000000, -135.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "buttons/sidebar/collapse",
  transform: "translate(448.000000, 135.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,-1.13686838e-13 C6.71572875,-1.13686838e-13 -1.42108547e-14,6.71572875 -1.42108547e-14,15 C-1.42108547e-14,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9758351,6.72575887 23.2742411,0.0241649367 15,-1.13686838e-13 Z",
  id: "Circle-Bg",
  fill: "#5C7284",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Arrow",
  strokeWidth: 1,
  fillRule: "evenodd",
  transform: "translate(7.000000, 8.000000)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.02712969,7 L17.0435589,7",
  id: "Line",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("polyline", {
  strokeWidth: 2,
  points: "8.50993565 13.954154 0.992331944 7 8.50993565 0.291919001"
})))));

function SvgIconFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CD87525A-6A4E-4D0A-8610-B1822BBEBBC2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterList);
export default __webpack_public_path__ + "static/media/icon_filter_list.8b60fbad.svg";
export { ForwardRef as ReactComponent };